enum TipoHoraEnum {
    Normal = 1,
    Eventual,
    Substituicao,
}

const TipoHoraEnumLabel = new Map<TipoHoraEnum, string>([
    [TipoHoraEnum.Normal, "Normal"],
    [TipoHoraEnum.Eventual, "Eventual"],
    [TipoHoraEnum.Substituicao, "Substituição"],
]);

export { TipoHoraEnum, TipoHoraEnumLabel };
